<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Jn8Zb9/tc-custom/9780544126350.jpg?1734283861112" alt="This image is the cover for the book Growing Up Gronk"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Growing Up Gronk
      </h1>
      <p class="bookDescription body article font2">
        <b>Huge boys, huge dreams, huge success—how one family from Buffalo put five boys on the track to realizing their athletic potential and making it “big.”</b><br/>  <br/> “The beauty of <i>Growing Up Gronk</i> is that you never really have to grow up at all. A fascinating look inside a larger-than-life football family.” —Dan Shaughnessy, bestselling author of <i>Francona: The Red Sox Years</i><br/>  <br/> It is so statistically unlikely as to be almost unbelievable. Somehow, the Gronkowski family has produced three sons who play in the NFL (Rob, Chris, and Dan), one who was drafted into Major League Baseball (Gordie Jr.), and another who is the starting fullback for Kansas State (Goose). Their father, Gordy, even played college football for Syracuse.<br/>  <br/> How did it happen? From an early age, Gordy realized the potential his sons had and worked with them to make the most of it. Beyond their monstrous size, physicality, and raw talent, he instilled in them a commitment to fitness, health, drive, and determination that would give his boys a leg up in ways other families simply couldn’t match. And the boys’ motivation certainly wasn’t something solely triggered by a driven father. They were like a pack of adolescent wolves readying themselves for the recruiting hunt. Still, all were honor roll students; the three oldest earned college degrees. Each was motivated and inspired by his brothers. Competition and bragging rights were—and continue to be—a big part of what makes the Gronkowskis tick. <i>Growing Up Gronk</i> reveals the secrets to the Gronkowskis’ astonishing collective success while opening the door to a lively, entertaining, one-of-a-kind household.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        The Gronkowski Family, Jeff Schober
      </h2>
      
      <p class="authorDescription body article">The Gronkowski Family includes father, Gordy Gronkowski, who played football at Syracuse University and is president of G&amp;G Fitness and his sons: Gordie Jr. a professional baseball player who was drafted by the Angels; Dan, a tight end with the Cleveland Browns; Chris, a fullback with the Denver Broncos; Rob, a superstar tight end with the New England Patriots; and Glenn, &ldquo;Goose,&rdquo; who plays Division 1 football at Kansas State. They are from Buffalo, New York.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?62a080eb